import {DefaultPage} from "@/components/DefaultPage";
import {ContentContainer} from "@/components/ContentContainer";
import React, {useEffect} from "react";
import PageHead from "@/components/PageHead";

export default function Imprint({page}) {

    return (
        <>
            <PageHead page={page}/>
            <ContentContainer headline={page?.headline} image={page?.hero_image?.formats?.large?.url}>
                <DefaultPage page={page}/>
            </ContentContainer>
        </>
    );
}

export const getStaticProps = async () => {
    const pageResponse = await fetch(`${process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"}/imprint`);
    const page = await pageResponse.json();

    return {
        props: {
            page
        },
        revalidate: parseInt(process.env.SSG_REVALIDATE_TIMEOUT)
    }
}
